import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { Table } from '../../../../packages/ui/organisms/table';

import Header from '../../../../components/v2/Header';
import PriorityEmpty from '../../../provider/member-detail/components/PriorityEmpty';

import { useStyles } from './index.styles';
import { getMemberConstructs } from '../../../../services/profile/profile.service';
import dayjs from '../../../../utils/dayjs';

const columns = [
  { id: 'constructName', label: 'Construct', sortable: false },
  { id: 'constructValue', label: 'Recent Value', sortable: false },
  { id: 'createdAt', label: 'Last Updated', sortable: false },
];

const MemberConstructs = () => {
  const classes = useStyles();
  const { memberId } = useParams();
  const [constructs, setConstructs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [value, setValue] = useState({
    search: {
      searchKey: '',
    },
    pagination: {
      currentPage: 1,
      rowsPerPage: 10,
    },
    sorter: {
      direction: 'asc',
      column: '',
    },
  });

  const renderColumns = columns.map(column => {
    if (column.id === 'constructName') {
      return {
        ...column,
        className: classes.constructNameColumn,
      };
    } else if (column.id === 'createdAt') {
      return {
        ...column,
        className: classes.constructUpdatedColumn,
        renderCell: createdAt => {
          return dayjs(createdAt).format('MM/DD/YYYY');
        },
      };
    }
    return column;
  });

  const fetchConstructs = async () => {
    try {
      setIsLoading(true);
      const response = await getMemberConstructs(memberId);
      setConstructs(response.data);
    } catch (error) {
      console.error('Error fetching constructs:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    void fetchConstructs();
  }, []);
  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
        <Header label="Constructs" />
        <Box display="flex" flexDirection="column" gap={3}>
          <Table
            gridProps={{
              columns: renderColumns,
              data: constructs,
              isLoading,
              emptyState: (
                <PriorityEmpty
                  title="No Patient Constructs generated yet."
                  description=""
                  glyph="lottie-symptomatic-factors"
                  glyphOrientation="portrait"
                  isEmptyWithLottie
                  lottieSize={128}
                />
              ),
            }}
            value={value}
            onChange={setValue}
            className={classes.table}
          />
        </Box>
      </Box>
    </>
  );
};

export default MemberConstructs;
